(() => {
  class ProductSliderHorizontalCardsElement extends HTMLElement {
    constructor() {
      super();
      this.seeMoreButton = null; // Declare a property for the button
      this.resizeHandler = null; // Store the resize handler to remove it later
    }

    connectedCallback() {
      this.expand();
      // Attach the resize event listener when the element is connected
      window.addEventListener("resize", this.handleResize.bind(this));
    }

    disconnectedCallback() {
      // Clean up event listener when the element is removed from the DOM
      if (this.seeMoreButton) {
        this.seeMoreButton.removeEventListener("click", this.expandClickHandler);
      }
      // Remove the resize event listener when the element is disconnected
      window.removeEventListener("resize", this.handleResize.bind(this));
    }

    expand() {
      this.seeMoreButton = this.querySelector(".product-slider-horizontal__see-more");

      // Define the click event handler method
      this.expandClickHandler = () => {
        this.classList.add("product-slider-horizontal--expand");
      };

      // Add the event listener to the button
      this.seeMoreButton.addEventListener("click", this.expandClickHandler);
    }

    handleResize() {
      // If the window width is greater than 360px, remove the 'expand' class
      if (window.innerWidth > 360) {
        this.classList.remove("product-slider-horizontal--expand");
      }
    }
  }
  // Register the custom element
  if (!customElements.get("products-slider-horizontal")) {
    customElements.define("products-slider-horizontal", ProductSliderHorizontalCardsElement);
  }
})();
